var ACTIONS = {
  FORM_LOADED: 'FORM_LOADED',
  SET_ACTIVE_PAGE: 'SET_ACTIVE_PAGE',
  SET_FIELD_VALUE: 'SET_FIELD_VALUE',
  SET_REPEATING_FIELD_VALUE: 'SET_REPEATING_FIELD_VALUE',
  SET_FIELD_TOUCHED: 'SET_FIELD_TOUCHED',
  SET_FIELD_BLURED: 'SET_FIELD_BLURED',
  SET_FIELD_ERROR: 'SET_FIELD_ERROR',
  SET_DATA: 'SET_DATA',
  SET_FORM_DIRTY: 'SET_FORM_DIRTY',
  SET_FORM_OPTIONS: 'SET_FORM_OPTIONS',
  SET_FORM_RENDER_OPTIONS: 'SET_FORM_RENDER_OPTIONS',
  SET_FORM_UPLOAD_FILE_CALLBACK: 'SET_FORM_UPLOAD_FILE_CALLBACK',
  SET_FIELDS_VALUES: 'SET_FIELDS_VALUES',
  SET_FIELDS_PROPERTIES: 'SET_FIELDS_PROPERTIES',
  SET_FIELDS_META: 'SET_FIELDS_META',
  SET_FIELD_META: 'SET_FIELD_META',
  ADD_FIELDS: 'ADD_FIELDS',
  UPDATE_VISIBILITY: 'UPDATE_VISIBILITY',
  FORM_DATA_CHANGED: 'FORM_DATA_CHANGED',
  CONTEXT_LOADED: 'CONTEXT_LOADED',
  BINDING_READY: 'BINDING_READY'
};
export default ACTIONS;